import { switchMap } from 'rxjs/operators';
import { IEpic, isTypeOf } from '@cbridge-utils/redux-observable';
import { IAuthDependencySegment } from '../_segments/IAuthDependencySegment';
import { AuthAction } from '../auth.action';

type IDependencies = IAuthDependencySegment;

export const logoutEpic: IEpic<{}, IDependencies> = (action$, _, dependencies) => action$.pipe(
  isTypeOf(AuthAction.logout),
  switchMap(() => {
    if (dependencies.auth.isInitialized() && dependencies.auth.isAuthenticated()) {
      dependencies.auth.logout();
      return [];
    }

    return [
      AuthAction.failed({ error: 'Auth initialization error' }),
    ];
  }),
);
